module.exports = __webpack_public_path__ + "static/img/guanChe.b03be476.png";